<template>
  <div :class="container">
    <div
      v-if="to === ''"
      class="story mr-4 mb-2"
      :class="{ active }"
      @mouseover="mouseover()"
      @mouseleave="mouseleave()"
    >
      <img
        v-if="showImage"
        :src="image"
        :alt="imageAlt"
        class="h-100 w-100 position-absolute"
        loading="lazy"
      />
      <div v-else class="position-absolute big-dot"></div>
      <div class="halfclip">
        <div class="clipped halfcircle"></div>
      </div>
      <div class="fixed halfcircle"></div>
    </div>
    <div
      v-else
      class="story mr-4 mb-2"
      :class="{ active }"
      @click="resetTimer"
      @mouseover="mouseover()"
      @mouseleave="mouseleave()"
    >
      <img
        v-if="showImage"
        :src="image"
        :alt="imageAlt"
        class="h-100 w-100 position-absolute"
        loading="lazy"
      />
      <div v-else class="position-absolute big-dot"></div>
      <div class="halfclip">
        <div class="clipped halfcircle"></div>
      </div>
      <div class="fixed halfcircle"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: false,
      default: ''
    },
    imageAlt: {
      type: String,
      required: false,
      default: 'story image'
    },
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    to: {
      type: String,
      required: false,
      default: ''
    },
    itemIndex: {
      type: Number,
      required: false,
      default: -1
    },
    showImage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isMouseover: false
    };
  },
  computed: {
    storyStyles() {
      return this.active ? 'active' : '';
    },
    container() {
      return !this.showImage ? 'story-container-small' : 'story-container';
    }
  },
  watch: {
    active(val) {
      if (val && this.isMouseover) this.$emit('pause');
    }
  },
  methods: {
    mouseover() {
      this.isMouseover = true;
      this.$emit('pause', this.active);
    },
    mouseleave() {
      this.isMouseover = false;
      this.$emit('resume', this.active);
    },
    resetTimer() {
      if (!this.active) {
        this.$emit('reset-timer-item', this.itemIndex);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.story-container,
.story-container-small {
  position: relative;
  img {
    clip-path: circle(20px at center);
  }
  .story {
    cursor: pointer;
    opacity: 0.3;
    &.active {
      opacity: 1;
    }
  }
  &:hover .story.active {
    .halfclip,
    .clipped,
    .fixed {
      animation-play-state: paused;
    }
  }
}
.story-container {
  margin-right: 1.5rem;
  width: 40px;
  height: 40px;
}
.story-container-small {
  margin-right: 1rem;
  width: 22px;
  height: 22px;
}
.halfclip {
  width: 50%;
  height: 100%;
  right: 0px;
  top: 0;
  position: absolute;
  overflow: hidden;
  transform-origin: left center;
}

.story.active .halfclip {
  animation: cliprotate 4s 1;
  transform: rotate(180deg);
}

@keyframes cliprotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(0deg);
  }
  50.01% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

.halfcircle {
  box-sizing: border-box;
  height: 100%;
  right: 0px;
  top: 0;
  position: absolute;
  border: solid 3px transparent;
  border-top-color: var(--exp-color);
  border-left-color: var(--exp-color);
  border-radius: 50%;
}

.clipped {
  width: 200%;
  transform: rotate(-45deg);
}
.story.active .clipped {
  transform: rotate(135deg);
  animation: rotate 2s linear 2;
}

@keyframes rotate {
  0% {
    transform: rotate(-45deg);
  }
  100% {
    transform: rotate(135deg);
  }
}

.fixed {
  width: 100%;
  transform: rotate(135deg);
  opacity: 0;
}

.story.active .fixed {
  opacity: 1;
  animation: showfixed 4s 1;
}

@keyframes showfixed {
  0% {
    opacity: 0;
  }
  49.99% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
.big-dot {
  height: 10px;
  width: 10px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin: 6px;
}
.active .big-dot {
  background-color: #000;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.6);
}
</style>
